import { Typography } from '@euler/app/components/typography';
import { HStack } from '@euler/components/layout/Stack';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { TOKENS } from '../constants';

export const FuelTypeChip = memo(({ fuelType }: { fuelType: string }) => {
  const { rpx } = useResponsiveContext();
  const isElectric = fuelType.includes('电');
  const bg = isElectric ? TOKENS.fuelElectricBg : TOKENS.fuelGasBg;
  const color = isElectric ? TOKENS.fuelElectricText : TOKENS.fuelGasText;
  return (
    <HStack
      css={`
        background-color: ${bg};
        border-radius: ${rpx(10)}px;
        padding: ${rpx(2)}px ${rpx(8)}px;
        align-items: center;
      `}
    >
      <Typography.Text size={rpx(10)} color={color} lineHeight={rpx(13)}>
        {isElectric ? '⚡' : '⛽'}
      </Typography.Text>
      <Typography.Label
        medium
        color={color}
        size={rpx(11)}
        lineHeight={rpx(14)}
        css={`
          margin-left: ${rpx(3)}px;
        `}
      >
        {fuelType}
      </Typography.Label>
    </HStack>
  );
});
